var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ActionConfirmModal",
    {
      ref: "modal",
      attrs: {
        modalType: "medium-modal",
        confirmTitle: _vm.$t("directory.msg.noPremisesAtTerminal.title"),
        confirmBtnName: _vm.$t("action.ok"),
        showCancelBtn: false,
      },
      on: {
        "action:afterClose": function () {
          return (_vm.isModalActivated = false)
        },
      },
    },
    [
      _c("div", { attrs: { slot: "content" }, slot: "content" }, [
        _vm.isModalActivated
          ? _c(
              "table",
              { staticClass: "no-premises-at-terminal-table" },
              [
                _c("thead", [
                  _c(
                    "tr",
                    _vm._l(
                      _vm.noPremisesAtTerminalTableHeaders,
                      function (header) {
                        return _c(
                          "th",
                          { key: header.attr, class: ["title", header.attr] },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(header.title) +
                                "\n          "
                            ),
                          ]
                        )
                      }
                    ),
                    0
                  ),
                ]),
                _vm._v(" "),
                _vm._l(_vm.companies, function (company, index) {
                  return _c(
                    "tbody",
                    {
                      key: company.id,
                      class: [index % 2 === 0 ? "row-even" : "row-odd"],
                    },
                    [
                      _c(
                        "tr",
                        _vm._l(
                          _vm.noPremisesAtTerminalTableHeaders,
                          function (header) {
                            return _c(
                              "td",
                              { key: header.attr, class: header.attr },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      company[header.attr] ||
                                        header.defaultValue
                                    ) +
                                    "\n          "
                                ),
                              ]
                            )
                          }
                        ),
                        0
                      ),
                      _vm._v(" "),
                      _vm._l(company.subCompanies, function (subCompany) {
                        return _c(
                          "tr",
                          { key: subCompany.id, staticClass: "sub-company" },
                          _vm._l(
                            _vm.noPremisesAtTerminalTableHeaders,
                            function (header) {
                              return _c(
                                "td",
                                { key: header.attr, class: header.attr },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        subCompany[header.attr] ||
                                          header.defaultValue
                                      ) +
                                      "\n          "
                                  ),
                                ]
                              )
                            }
                          ),
                          0
                        )
                      }),
                    ],
                    2
                  )
                }),
              ],
              2
            )
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }